import { render, staticRenderFns } from "./InvitationList.vue?vue&type=template&id=36c91804"
import script from "./InvitationList.vue?vue&type=script&lang=ts"
export * from "./InvitationList.vue?vue&type=script&lang=ts"
import style0 from "./InvitationList.vue?vue&type=style&index=0&id=36c91804&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports